// badge.style.js
import { StyleSheet } from "react-native";

export default StyleSheet.create({
  badgeContainer: {
    position: "relative",
  },
  badgeContainerAbsolute: {
    position: "absolute",
    zIndex: 1,
    right: 0,
    top: 0,
    transform: [{ translateX: "5%" }, { translateY: "-5%" }],
  },
  badge: {
    alignItems: "center",
    justifyContent: "center",
  },
});
